import React, { useState } from 'react';
import SettingsPanel from './SettingsPanel';

const MenuDrawer: React.FC = () => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <>
      {/* ☰ Button */}
      <button
        onClick={() => setShowMenu(!showMenu)}
        style={{
          position: 'fixed',
          top: '1rem',
          right: '1rem',
          zIndex: 10000,
          background: '#222',
          color: '#ffdd80',
          border: '1px solid #444',
          borderRadius: '6px',
          padding: '0.5rem 1rem',
          fontSize: '1.2rem',
          cursor: 'pointer',
        }}
        aria-label="Toggle Settings"
      >
        ☰
      </button>

      {/* Slide-Out Menu */}
      {showMenu && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            width: '320px',
            height: '100vh',
            backgroundColor: '#111',
            color: '#fff',
            zIndex: 9999,
            padding: '1rem',
            borderLeft: '1px solid #444',
            overflowY: 'auto',
          }}
        >
          <h3 style={{ color: '#ffdd80' }}>Settings</h3>
          <SettingsPanel />
        </div>
      )}
    </>
  );
};

export default MenuDrawer;
